import { memo, useSyncExternalStore } from 'react'

import { AsyncToaster } from './AsyncToaster'
import { ToasterPlaceholder } from './ToasterPlaceholder'
import { getIsToasterRequested, subscribeToaster } from './toasterRequest'
import type { TToasterProps } from './Toaster.types'

const getServerSnapshot = () => false

export const Toaster = memo((props: TToasterProps) => {
    const isRequested = useSyncExternalStore(
        subscribeToaster,
        getIsToasterRequested,
        getServerSnapshot,
    )

    if (!isRequested) {
        return <ToasterPlaceholder />
    }

    return <AsyncToaster {...props} />
})
